import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    public auth: AuthService,
    private router: Router
  ) { }

  canActivate(): Promise<boolean> {
    return this.canUserLogin();
  }

  async canUserLogin(){
    try{
      const user = await this.auth.getCurrentUserAlt();
      if(user){
        this.router.navigate(["/perfil"]);
        return false;
      }
      else{
        return true;
      }
    }catch(error){
      return true;
    }
  }

}


